// src/context/ThemeColorContext.js
import React, { createContext, useContext, useState } from 'react';

const ThemeColorContext = createContext();

export const ThemeColorProvider = ({ children }) => {
  const [theme, setTheme] = useState({
    themeColor: '#0d6efd',
    themeLightColor: '#0d6efdcc',
  });

  const updateThemeColors = (newColors) => {
    setTheme((prev) => ({ ...prev, ...newColors }));

    Object.entries(newColors).forEach(([key, value]) => {
      document.documentElement.style.setProperty(`--${key}`, value);
    });
  };

  return (
    <ThemeColorContext.Provider value={{ theme, updateThemeColors }}>
      {children}
    </ThemeColorContext.Provider>
  );
};

export const useThemeColor = () => useContext(ThemeColorContext);
